import { defineMessage } from 'services/localization';

export const messages = {
    postApprovalChangeDetected: defineMessage('changes_have_been_made__s_online_after_approval'),
    rejectedExternally: defineMessage('request_has_been_rejected_by_quickbooks_online'),
    emailToVendorSent: defineMessage('templatename_has_been_sent_to_the_vendor'),
    emailToCustomerSent: defineMessage('templatename_has_been_sent_to_the_customer'),
    statusRejected: defineMessage('the_status_has_been_rejected_by_quickbooks_online'),
};
